export default {
  isochronesDetails: {
    polygons: 'Polygone',
    center: 'Zentrum',
    reachCenters: 'Erreichbarkeits-Zentren',
    toggleVisibility: 'Sichtbarkeit umschalten',
    opacity: 'Deckkraft'
  }
}
